//Componentes Generales
import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import NewProductItm from "../newProductItm/NewProductItm";
import AutocompleteV2 from "../AutoCompleteV2/AutoCompleteV2";
import moment from "moment";
import "bootstrap/dist/css/bootstrap.min.css";
import Tesseract from "tesseract.js";
import { getDocument, GlobalWorkerOptions } from "pdfjs-dist";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import SelectList from "../../components/SelectList/SelectList.js";
import DropDownPicker from "../DropDownPicker/DropDownPicker.js";

//Context
import proveedoresContext from "../../context/proveedores/proveedoresContext.js";
import authContext from "../../context/authentication/authContex.js";

//Api
import {
  downloadFile,
  getFile,
  getTDocsByCodForAndCodOriAndNroCta,
  getRemitosFromOCP,
  processInvoiceWithDocumentAI,
} from "../../api/transactionDocuments.js";
import {
  getConceptosByTDoc,
  getLastMappings,
} from "../../api/concepto.js";
import { verifyLicense } from "../../api/license";
import { getSubcuentasByDimension } from "../../api/subcuenta";

//Util
import {
  formatosFecha,
  getNewFormattedDate,
  generarFechasConNombreMes,
} from "../../utils/formatDate.js";

// Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faSpinner, faMagnifyingGlass, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

import Swal from "sweetalert2";

// Estilos
import "./FormReq.css";

// Utils
import {
  getMontoCuartoFormato,
  getMontoEnLetras,
  getMontoPrimerFormato,
  getMontoSegundoFormato,
  getMontoTercerFormato,
  monedas,
} from "../../utils/monedas.js";
import {
  formatCuitGuiones,
  formatCuitGuionPunto,
  formatCuitPuntoGuion,
  formatCuitPuntos,
  getMimeTypeByExtension,
} from "../../utils/funciones.js";

//ENTORNO
import { ENTORNO } from "../../config/config";
import { GUARDAR_TDOCS_SIN_VALIDACION } from "../../utils/permisos.js";
import { getPendingFile } from "../../utils/pendingFile";

// Crea un blob URL para el worker evitando el error de MIME type en el servidor
let _pdfWorkerBlobUrl = null;
const getPdfWorkerUrl = async () => {
  if (_pdfWorkerBlobUrl) return _pdfWorkerBlobUrl;
  const response = await fetch(`${process.env.PUBLIC_URL}/pdf.worker.min.mjs`);
  const buffer = await response.arrayBuffer();
  const blob = new Blob([buffer], { type: "application/javascript" });
  _pdfWorkerBlobUrl = URL.createObjectURL(blob);
  return _pdfWorkerBlobUrl;
};

// Constante con estructura del producto.
const estructura_producto = {
  tipPro: "",
  artCod: "",
  codRed: "",
  descrp: "",
  quantity: "1",
  textAdic: "",
};

const getEstructuraProducto = () => ({
  tipPro: "",
  artCod: "",
  codRed: "",
  descrp: "",
  quantity: "1",
  textAdic: "",
});

function FormReq({
  edicion,
  req,
  files = [],
  itemList,
  productList,
  guardarReq,
  cerrar,
}) {
  const [loading, setLoading] = useState(true);
  const [cliente, setCliente] = useState(ENTORNO);
  const [requeriment, setRequeriment] = useState(req);
  const [subcuentaSelected, setSubcuentaSelected] = useState({
    codDim: "",
    codDimDescrp: "",
    subCue: "",
    subCueDescrp: "",
  });
  const [formattedImporte, setFormattedImporte] = useState("");
  const [formattedCotizacion, setFormattedCotizacion] = useState("");
  const [displayOptions, setDisplayOptions] = useState();
  const [items, setItems] = useState(
    itemList.length === 0
      ? [estructura_producto]
      : itemList.concat([estructura_producto]),
  );
  const [isModifiedOriginalFile, setIsModifiedOriginalFile] = useState(false);
  const [isModifiedFile, setIsModifiedFile] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState(files);
  const [selectionColor, setSelectionColor] = useState(false);
  const [controlBotonEnviar, setControlBotonEnviar] = useState(false);
  const [onFocus, setOnFocus] = useState("");
  const [tiposComprobantes, setTiposComprobantes] = useState([]);
  const [isProfileProv, setIsProfileProv] = useState(false);

  const [checkOcApl, setcheckOcApl] = useState(
    (req.ocsApl?.length === 0) && edicion == "Edicion" ? true : false,
  );
  const [ptoVentaComprobante, setPtoVentaComprobante] = useState(
    req.codOri ? req.codOri.split("-")[0] : "",
  );
  const [nroComprobante, setNroComprobante] = useState(
    req.codOri ? req.codOri.split("-")[1] : "",
  );
  const importeRef = useRef(null);
  const cotizacionRef = useRef(null);
  const [opcionesMoneda, setOpciones] = useState(monedas);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const [processingPDF, setProcessingPDF] = useState(false);
  const [skipValidation, setSkipValidation] = useState(false);
  const [processingDocumentAI, setProcessingDocumentAI] = useState(false);
  const [licencia, setLicencia] = useState({});
  const [text, setText] = useState(null);
  const [subcuentas, setSubcuentas] = useState([]);
  const [conceptos, setConceptos] = useState([]);
  const [mostrarControles, setMostrarControles] = useState(true);

  const [aditionalDocs, setAditionalDocs] = useState(null);

  const pendingFileRef = useRef(null);

  const inputRef = useRef(null);

  const observadaRef = useRef(false);

  const msgsObservadaRef = useRef({
    cuitReceptor: "",
    cuitEmisor: "",
    nroFactura: "",
    fecha: "",
    importe: "",
  });

  const provContext = useContext(proveedoresContext);
  const { proveedores, actualizarProveedores } = provContext;
  const proveedoresActivos = proveedores.filter((p) => p.debaja !== "S");
  const productListActivos = productList.filter((p) => p.debaja !== "S");
  const subcuentasActivas = subcuentas.filter((s) => s.debaja !== "S");
  const aContext = useContext(authContext);
  const {
    usuario,
    globalSettings,
    obtenerGlobalSettings,
    updateGlobalSettings,
  } = aContext;

  const isAdminOrControl = usuario?.userType?.some((item) =>
    GUARDAR_TDOCS_SIN_VALIDACION.includes(item.typeName),
  );

  const isUserTypeProv = usuario?.userType?.some((item) => item.typeName === "PROV");

  // Determinar si la extracción por IA está habilitada según globalSettings y tipo de usuario
  const aiExtractionEnabled =
    globalSettings?.reemplazaValidacionPorExtraccion === true &&
    (!isProfileProv || globalSettings?.extraccionAplicaProveedores === true);

  const solicitaOrdenCompra = globalSettings?.solicitaOrdenCompra !== false;

  const navigate = useNavigate();

  useEffect(() => {
    let newRequeriment = {
      ...requeriment,
      quantity: 1,
      ocsApl: req.ocsApl?.length > 0
        ? { nroFor: req.ocsApl.map((oc) => ({ label: String(oc.nroFor), value: String(oc.nroFor) })) }
        : { nroFor: [] },
    };
    const fn = async () => {
      try {
        await obtenerGlobalSettings();
        if (!usuario.nroCta || usuario.nroCta == "") {
          await actualizarProveedores();
        } else {
          newRequeriment.nroCta = usuario.nroCta;
          newRequeriment.nroCtaDescrp = usuario.fullName;
          newRequeriment.cuitProv = usuario.userName.replaceAll("-", "");
          setIsProfileProv(true);
        }
        const respLicencia = await verifyLicense();
        if (respLicencia.data.data.nombre.toLowerCase().includes("solimeno")) {
          setTiposComprobantes([
            { tipo: "FA", descripcion: "Factura" },
            { tipo: "NCA", descripcion: "Nota de Crédito" },
            { tipo: "NDA", descripcion: "Nota de Débito" },
          ]);
        } else {
          setTiposComprobantes([
            { tipo: "FAC", descripcion: "Factura" },
            { tipo: "NC", descripcion: "Nota de Crédito" },
            { tipo: "ND", descripcion: "Nota de Débito" },
          ]);
        }
        setLicencia(respLicencia.data.data);

        // Check if a file was dropped from Home's drop zone
        const pendingFile = getPendingFile();
        if (pendingFile) {
          setSelectedFiles([pendingFile]);
          setIsModifiedFile(true);
          pendingFileRef.current = pendingFile;
        }
      } catch (error) {
        console.error("Error en inicialización FormReq:", error);
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      }
    };
    fn();
    //handlerIniciarlizarFiltros();
    let newItem = [
      {
        artCod: "1",
        codRed: "1",
        descrp: "Producto Genérico",
        quantity: "1",
        textAdic: "",
        tipPro: "T1",
      },
      { ...getEstructuraProducto() },
    ];
    setRequeriment(newRequeriment);
    setItems(newItem);
  }, []);

  // Auto-scan pending file once loading is done (all state is populated)
  useEffect(() => {
    if (!loading && pendingFileRef.current && aiExtractionEnabled) {
      const file = pendingFileRef.current;
      pendingFileRef.current = null;
      handleAutoFillFromDocument(file);
    }
  }, [loading]);

  useEffect(() => {
    try {
      const fn = async () => {
        if (edicion) {
          const formatted = formatWithCommas(requeriment.importe);
          setFormattedImporte(formatted);
          if (requeriment.cotizacion) {
            const formatted = formatWithCommas(requeriment.cotizacion);
            setFormattedCotizacion(formatted);
          }
          // Cargo los documentos adicionales recuperados desde S3
          if (req.aditionalDocs?.length > 0) {
            setAditionalDocs(req.aditionalDocs);
          }
          // Cargar conceptos desde colección separada
          try {
            const concResp = await getConceptosByTDoc(req.tDocCodFor, req.tDocNroFor);
            const conceptosDB = concResp?.data?.data || [];
            if (conceptosDB.length > 0) {
              const conceptosCargados = conceptosDB.map((c) => ({
                description: c.description || "",
                quantity: c.quantity || 1,
                unitPrice: c.unitPrice || 0,
                amount: c.amount || 0,
                codigoERP: c.tipPro
                  ? {
                      tipPro: c.tipPro,
                      artCod: c.artCod,
                      codRed: c.codRed,
                      descrp: c.descrpERP,
                    }
                  : null,
              }));
              setConceptos(conceptosCargados);
            }
          } catch (e) {
            console.warn("No se pudieron cargar conceptos:", e);
          }
        }

        if (
          globalSettings.requiredSubcuenta == true &&
          globalSettings.codDim !== subcuentaSelected.codDim
        ) {
          const respSubcuentas = await getSubcuentasByDimension(
            globalSettings.codDim,
          );
          setSubcuentas(respSubcuentas.data.data);
          setSubcuentaSelected({
            codDim: globalSettings.codDim,
            codDimDescrp: globalSettings.codDimDescrp,
            subCue: edicion && req.subCue ? req.subCue : "",
            subCueDescrp: edicion && req.subCueDescrp ? req.subCueDescrp : "",
          });
        } else if (
          globalSettings.requiredSubcuenta == false &&
          subcuentaSelected.codDim
        ) {
          setSubcuentaSelected({
            codDim: "",
            codDimDescrp: "",
            subCue: "",
            subCueDescrp: "",
          });
        }
      };
      fn();
    } catch (error) {
      console.error("Error en actualización FormReq:", error);
    }
  }, [globalSettings]);

  const handleChangeCodOri = (data) => {
    setRequeriment({ ...requeriment, codOri: data });
  };

  const handleChangePtoVenta = (e) => {
    const maxLen = ENTORNO.toLowerCase().includes("solimeno") ? 4 : 5;
    const value = e.target.value.replace(/\D/g, "").slice(0, maxLen);
    setPtoVentaComprobante(value);
    setRequeriment({
      ...requeriment,
      codOri:
        value && nroComprobante
          ? `${value}-${nroComprobante}`
          : value || nroComprobante || "",
    });
  };

  const handleChangeNroComprobante = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 8);
    setNroComprobante(value);
    setRequeriment({
      ...requeriment,
      codOri:
        ptoVentaComprobante && value
          ? `${ptoVentaComprobante}-${value}`
          : ptoVentaComprobante || value || "",
    });
  };

  const handleBlurPtoVenta = () => {
    if (ptoVentaComprobante && ptoVentaComprobante.length > 0) {
      const padded = ptoVentaComprobante.padStart(
        ENTORNO.toLowerCase().includes("solimeno") ? 4 : 5,
        "0",
      );
      setPtoVentaComprobante(padded);
      setRequeriment({
        ...requeriment,
        codOri:
          padded && nroComprobante
            ? `${padded}-${nroComprobante}`
            : padded || nroComprobante || "",
      });
    }
  };

  const handleBlurNroComprobante = () => {
    if (nroComprobante && nroComprobante.length > 0) {
      const padded = nroComprobante.padStart(8, "0");
      setNroComprobante(padded);
      setRequeriment({
        ...requeriment,
        codOri:
          ptoVentaComprobante && padded
            ? `${ptoVentaComprobante}-${padded}`
            : ptoVentaComprobante || padded || "",
      });
    }
  };

  const handleChangeProveedor = async (value) => {
    const proveedorSeleccionado = proveedores.find(
      (p) =>
        `${p.nroCta}`.replace(/\s+/g, "") ===
        value.value.split(" ~ ")[0].replace(/\s+/g, ""),
    );

    if (proveedorSeleccionado !== undefined) {
      setRequeriment({
        ...requeriment,
        nroCta: proveedorSeleccionado.nroCta,
        nroCtaDescrp: proveedorSeleccionado.nombre,
        cuitProv: proveedorSeleccionado.cuit,
      });
    }
  };

  const handleChangeSubcuenta = async (value) => {
    const subcuentaSeleccionada = subcuentas.find(
      (s) =>
        `${s.subCue}`.replace(/\s+/g, "") ===
        value.value.split(" ~ ")[0].replace(/\s+/g, ""),
    );

    if (subcuentaSeleccionada !== undefined) {
      setSubcuentaSelected({
        ...subcuentaSelected,
        subCue: subcuentaSeleccionada.subCue,
        subCueDescrp: subcuentaSeleccionada.subCueDescrp,
      });
    }
  };

  const handleChangeTipoComprobante = async (value) => {
    const tipoComprobanteSeleccionado = tiposComprobantes.find(
      (tC) =>
        `${tC.tipo}`.replace(/\s+/g, "") ===
        value.value.split(" ~ ")[0].replace(/\s+/g, ""),
    );

    if (tipoComprobanteSeleccionado !== undefined) {
      setRequeriment({
        ...requeriment,
        tDocCodFor: tipoComprobanteSeleccionado.tipo,
        tDocCodForDescrp: tipoComprobanteSeleccionado.descripcion,
      });
    }
  };

  const sanitize = (value) => {
    // quitar caracteres que no sean dígitos o punto decimal
    let v = value.replace(/[^0-9.]/g, "");

    // permitir solo un punto
    const parts = v.split(".");
    if (parts.length > 2) {
      v = parts.shift() + "." + parts.join("");
    }

    return v;
  };

  const formatWithCommas = (value) => {
    if (!value) return "";

    const num = Number(value);
    if (isNaN(num)) return "";

    return num.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const handleChangeImporte = (e) => {
    const input = sanitize(e.target.value);

    setRequeriment({
      ...requeriment,
      importe: input, // guardado interno sin formatear
    });

    setFormattedImporte(input); // lo que ve mientras escribe
  };

  const handleFocusImporte = () => {
    setFormattedImporte(requeriment.importe || "");
  };

  const handleBlurImporte = () => {
    const raw = requeriment.importe || "";
    const formatted = formatWithCommas(raw);

    setFormattedImporte(formatted);
  };

  const handleChangeCotizacion = (e) => {
    const input = sanitize(e.target.value);

    setRequeriment({
      ...requeriment,
      cotizacion: input, // guardado interno sin formatear
    });

    setFormattedCotizacion(input); // lo que ve mientras escribe
  };

  const handleFocusCotizacion = () => {
    setFormattedCotizacion(requeriment.cotizacion || "");
  };

  const handleBlurCotizacion = () => {
    const raw = requeriment.cotizacion || "";
    const formatted = formatWithCommas(raw);

    setFormattedCotizacion(formatted);
  };

  const handleChangeMoneda = async (value) => {
    const monedaSeleccionada = opcionesMoneda.find(
      (o) =>
        `${o}`.replace(/\s+/g, "") ===
        value.value.split(" ~ ")[0].replace(/\s+/g, ""),
    );

    if (monedaSeleccionada !== undefined) {
      if (monedaSeleccionada == "PESOS") {
        setRequeriment({
          ...requeriment,
          moneda: monedaSeleccionada,
          cotizacion: "",
        });
      } else {
        setRequeriment({
          ...requeriment,
          moneda: monedaSeleccionada,
        });
      }
    }
  };

  const handleChangeDateOfIssue = (data) => {
    const fecha = new Date(data.concat("T00:00:00.000"));
    setRequeriment({ ...requeriment, dateOfIssue: fecha });
  };

  const handleChangeEmpresaReceptora = (value) => {
    const lista = globalSettings?.empresasReceptoras || [];
    const seleccionada = lista.find((e) => `${e.cuit}` === `${value.value}`);
    if (seleccionada) {
      setRequeriment((prev) => ({
        ...prev,
        empresaReceptora: {
          cuit: seleccionada.cuit,
          razonSocial: seleccionada.razonSocial || "",
        },
      }));
    }
  };

  const handleAutoFillFromDocument = async (fileOverride) => {
    const file = fileOverride || (selectedFiles && selectedFiles.length > 0 ? selectedFiles[0] : null);
    if (!file) return;
    setProcessingDocumentAI(true);
    try {
      const resp = await processInvoiceWithDocumentAI(file);
      const { data } = resp.data;

      if (!data) {
        Swal.fire({
          title: "No se pudieron extraer datos",
          text: "No se encontraron campos reconocibles en el documento.",
          icon: "warning",
        });
        return;
      }

      console.log("Document AI response data:", data);
      console.log("Line items:", data.lineItems);

      const camposCompletados = [];
      const camposNoCompletados = [];

      let newRequeriment = { ...requeriment };

      // Proveedor
      if (data.nroCta && !isProfileProv) {
        const proveedorEncontrado = proveedores.find(
          (p) => p.nroCta === data.nroCta
        );
        if (proveedorEncontrado) {
          newRequeriment.nroCta = proveedorEncontrado.nroCta;
          newRequeriment.nroCtaDescrp = proveedorEncontrado.nombre;
          newRequeriment.cuitProv = proveedorEncontrado.cuit;
          camposCompletados.push("Proveedor");
        } else {
          camposNoCompletados.push("Proveedor");
        }
      } else if (data.cuitEmisor && !isProfileProv) {
        camposNoCompletados.push("Proveedor (CUIT no registrado)");
      }

      // Tipo comprobante
      if (data.tipoComprobante) {
        const tipoEncontrado = tiposComprobantes.find(
          (tC) => tC.tipo === data.tipoComprobante
        );
        if (tipoEncontrado) {
          newRequeriment.tDocCodFor = tipoEncontrado.tipo;
          newRequeriment.tDocCodForDescrp = tipoEncontrado.descripcion;
          camposCompletados.push("Tipo de comprobante");
        } else {
          camposNoCompletados.push("Tipo de comprobante");
        }
      } else {
        camposNoCompletados.push("Tipo de comprobante");
      }

      // Punto de venta y número comprobante
      if (data.ptoVenta || data.nroComprobante) {
        const pvLen = ENTORNO.toLowerCase().includes("solimeno") ? 4 : 5;
        const pv = data.ptoVenta ? data.ptoVenta.padStart(pvLen, "0") : "";
        const nc = data.nroComprobante
          ? data.nroComprobante.padStart(8, "0")
          : "";
        setPtoVentaComprobante(pv);
        setNroComprobante(nc);
        newRequeriment.codOri = pv && nc ? `${pv}-${nc}` : pv || nc || "";
        camposCompletados.push("Nro. comprobante");
      } else {
        camposNoCompletados.push("Nro. comprobante");
      }

      // Fecha
      if (data.dateOfIssue) {
        const fecha = new Date(data.dateOfIssue + "T00:00:00.000");
        if (!isNaN(fecha.getTime()) && /^\d{4}-\d{2}-\d{2}$/.test(data.dateOfIssue)) {
          newRequeriment.dateOfIssue = fecha;
          camposCompletados.push("Fecha de emisión");
        } else {
          camposNoCompletados.push("Fecha de emisión");
        }
      } else {
        camposNoCompletados.push("Fecha de emisión");
      }

      // Importe
      if (data.importe) {
        newRequeriment.importe = data.importe.toString();
        setFormattedImporte(
          data.importe.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        );
        camposCompletados.push("Importe");
      } else {
        camposNoCompletados.push("Importe");
      }

      // Moneda
      if (data.moneda) {
        const monedaMap = { ARS: "PESOS", USD: "DOLAR", EUR: "EURO" };
        const monedaMapeada = monedaMap[data.moneda] || "PESOS";
        newRequeriment.moneda = monedaMapeada;
        if (monedaMapeada === "PESOS") {
          newRequeriment.cotizacion = "";
        }
        camposCompletados.push("Moneda");
      }

      // Empresa receptora (auto-match por IA)
      if (data.empresaReceptoraMatch?.cuit) {
        newRequeriment.empresaReceptora = {
          cuit: data.empresaReceptoraMatch.cuit,
          razonSocial: data.empresaReceptoraMatch.razonSocial || "",
        };
        camposCompletados.push("Empresa receptora");
      } else if (data.cuitReceptorExtraido) {
        camposNoCompletados.push("Empresa receptora (CUIT receptor no registrado)");
      }

      setRequeriment(newRequeriment);

      // Poblar conceptos desde line items de Document AI
      if (data.lineItems && data.lineItems.length > 0) {
        const conceptosMapeados = data.lineItems
          .filter((item) => (item.description || "").trim() !== "")
          .map((item) => {
            const qty = item.quantity || 1;
            const amount = item.amount || 0;
            return {
              description: item.description || "",
              quantity: qty,
              unitPrice: qty > 0 ? amount / qty : 0,
              amount,
              codigoERP: null,
            };
          });
        setConceptos(conceptosMapeados);
        camposCompletados.push(`Conceptos (${conceptosMapeados.length} ítems)`);
      } else {
        camposNoCompletados.push("Conceptos (sin ítems detectados)");
      }

      // Auto-asignar códigos ERP desde mapeos históricos
      const nroCtaParaMapeo = newRequeriment.nroCta || data.nroCta;
      if (data.lineItems && data.lineItems.length > 0 && nroCtaParaMapeo) {
        try {
          const mappingsResp = await getLastMappings(nroCtaParaMapeo);
          const mappings = mappingsResp?.data?.data || [];
          if (mappings.length > 0) {
            const conceptosMapeados = data.lineItems
              .filter((item) => (item.description || "").trim() !== "")
              .map((item) => {
              const descNorm = (item.description || "").trim().toUpperCase();
              const match = mappings.find(
                (m) => m.descriptionAI.trim().toUpperCase() === descNorm
              );
              const qty = item.quantity || 1;
              const amount = item.amount || 0;
              return {
                description: item.description || "",
                quantity: qty,
                unitPrice: qty > 0 ? amount / qty : 0,
                amount,
                codigoERP: match
                  ? {
                      tipPro: match.tipPro,
                      artCod: match.artCod,
                      codRed: match.codRed,
                      descrp: match.descrpERP,
                    }
                  : null,
              };
            });
            setConceptos(conceptosMapeados);
          }
        } catch (e) {
          // Si falla obtener mapeos, no es crítico
          console.warn("No se pudieron obtener mapeos históricos:", e);
        }
      }

      // Build summary message
      let htmlMsg = "";
      if (camposNoCompletados.length > 0) {
        htmlMsg += `<b style="color:#d33;">Campos no detectados:</b><br/>- ${camposNoCompletados.join(
          "<br/>- "
        )}<br/><br/>`;
      }
      if (camposCompletados.length > 0) {
        htmlMsg += `<b>Campos completados:</b><br/>- ${camposCompletados.join(
          "<br/>- "
        )}<br/><br/>`;
      }
      if (data.cuitReceptorValido === false && data.cuitReceptorExtraido) {
        htmlMsg += `<br/><b style="color:orange;">Atención:</b> El CUIT receptor extraído (${data.cuitReceptorExtraido}) no coincide con el de la empresa.`;
      }

      Swal.fire({
        title: "Escaneo completado",
        html: htmlMsg,
        icon: camposCompletados.length > 0 ? "success" : "warning",
      });
    } catch (error) {
      console.error("Error en Document AI:", error);
      Swal.fire({
        title: "Error al escanear",
        text:
          error?.response?.data?.message ||
          "Ocurrió un error al procesar el documento.",
        icon: "error",
      });
    } finally {
      setProcessingDocumentAI(false);
    }
  };

  const handleChangObservation = (data) => {
    setRequeriment({ ...requeriment, observ: data });
  };

  const handleagregaItem = (data) => {
    //Se le asigna un id random al nuevo producto añadido. Esto es para facilitar la eliminación del item en caso de ser necesario.
    const tempData = { ...data, usr_id: (Math.random() * 100).toString() };
    //Se le asigna un id random al item vacio. Esto es para facilitar la eliminación del item en caso de ser necesario.
    const nuevaEstructura = {
      ...estructura_producto,
      usr_id: (Math.random() * 100).toString(),
    };
    //Logica para determinar donde inserta el item vacio.
    const temp_List = items.length === 1 ? [nuevaEstructura] : items;
    const newLista =
      temp_List.length === 1
        ? [tempData, ...temp_List]
        : [
            ...temp_List.filter((d) => d.artCod !== ""),
            tempData,
            nuevaEstructura,
          ];

    setItems(newLista);
    console.log(newLista);
  };

  const handleDeleteConcept = (item, i) => {
    if (i !== items.length - 1) {
      setItems(
        items.filter((data, index) => {
          if (index !== i) {
            return data;
          }
        }),
      );
    }
  };

  const handleChangeItm = (data, i) => {
    const newLista = items.map((it, index) => {
      return it.codRed === data.codRed &&
        it.artCod === data.artCod &&
        index === i
        ? data
        : it;
    });
    setItems(newLista);
  };

  const handleFileInputChange = (e) => {
    if (e.target.files.length === 0) return;

    setIsModifiedFile(true);

    const filesArray = Array.from(e.target.files);
    const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50 MB en bytes

    for (const file of filesArray) {
      const allowedTypes = ["application/pdf", "image/jpeg"];
      if (!allowedTypes.includes(file.type)) {
        Swal.fire({
          title: "Hubo un error en la validación!",
          text: "Sólo se permiten archivos PDF o JPG/JPEG",
          icon: "error",
        });
        e.target.value = null;
        return;
      }

      const allowedExtensions = ["pdf", "jpg", "jpeg"];
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (!allowedExtensions.includes(fileExtension)) {
        Swal.fire({
          title: "Hubo un error en la validación!",
          text: "Extensión no permitida",
          icon: "error",
        });
        e.target.value = null;
        setProcessingPDF(false);
        return;
      }

      // Validación de tamaño (50 MB máximo por archivo)
      if (file.size > MAX_FILE_SIZE) {
        Swal.fire({
          title: "Archivo demasiado grande!",
          text: `El archivo "${
            file.name
          }" supera el límite de 50 MB. Tamaño actual: ${(
            file.size /
            (1024 * 1024)
          ).toFixed(2)} MB`,
          icon: "error",
        });
        e.target.value = null;
        setProcessingPDF(false);
        return;
      }
    }

    const newFiles = [...e.target.files];
    setSelectedFiles([...selectedFiles, ...newFiles]);
    if (edicion == "Edicion" && isModifiedOriginalFile == false) {
      setIsModifiedOriginalFile(true);
    }
    e.target.value = null;
    setProcessingPDF(false);

    // Auto-scan with Document AI when adding a file (not in edit mode)
    if (!edicion && newFiles.length > 0 && aiExtractionEnabled) {
      handleAutoFillFromDocument(newFiles[0]);
    }
  };

  /**
   * Extrae texto nativo del PDF (sin OCR) - más preciso para PDFs con texto seleccionable
   * Preserva la estructura del documento agrupando elementos por línea según su posición Y
   */
  const extractTextFromPdf = async (file) => {
    try {
      GlobalWorkerOptions.workerSrc = await getPdfWorkerUrl();
      const arrayBuffer = await file.arrayBuffer();
      const pdf = await getDocument({ data: arrayBuffer }).promise;
      let fullText = "";

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const textContent = await page.getTextContent();

        // Agrupar items por línea usando su posición Y (transform[5])
        const lineMap = new Map();
        const tolerance = 5; // Tolerancia para considerar items en la misma línea

        for (const item of textContent.items) {
          if (!item.str || item.str.trim() === "") continue;

          const y = Math.round(item.transform[5] / tolerance) * tolerance;
          const x = item.transform[4];

          if (!lineMap.has(y)) {
            lineMap.set(y, []);
          }
          lineMap.get(y).push({ x, text: item.str });
        }

        // Ordenar líneas por Y (de arriba a abajo) y elementos por X (de izquierda a derecha)
        const sortedLines = Array.from(lineMap.entries())
          .sort((a, b) => b[0] - a[0]) // Y descendente (arriba primero)
          .map(([, items]) => {
            return items
              .sort((a, b) => a.x - b.x) // X ascendente (izquierda primero)
              .map((item) => item.text)
              .join(" ");
          });

        const pageText = sortedLines.join("\n");
        fullText += `\n--- PAGE ${i} ---\n${pageText}`;
      }

      return fullText.trim();
    } catch (error) {
      console.log("Error en extractTextFromPdf: ", error);
      return "";
    }
  };

  /**
   * Corrige caracteres comúnmente confundidos por el OCR
   * Especialmente útil para fechas con nombres de meses
   */
  const postProcessOcrText = (text) => {
    if (!text) return text;

    // Mapeo de caracteres comúnmente confundidos
    const corrections = {
      "£": "E",
      "€": "E",
      "∈": "E",
      "|": "I",
      "!": "I",
      $: "S",
      "§": "S",
    };

    // Primero aplicar correcciones generales de caracteres especiales
    let correctedText = text;
    for (const [wrong, correct] of Object.entries(corrections)) {
      correctedText = correctedText.split(wrong).join(correct);
    }

    // Patrones específicos para meses mal leídos (case insensitive)
    const monthCorrections = [
      // Enero
      { pattern: /\b3N[3E]RO\b/gi, replacement: "ENERO" },
      { pattern: /\b[3E]N[3E]\b/gi, replacement: "ENE" },
      // Febrero
      { pattern: /F[3E]BR[3E]RO/gi, replacement: "FEBRERO" },
      { pattern: /F[3E]B/gi, replacement: "FEB" },
      // Marzo
      { pattern: /MARZ[0O]/gi, replacement: "MARZO" },
      // Abril
      { pattern: /ABR[1I]L/gi, replacement: "ABRIL" },
      // Mayo (generalmente OK)
      // Junio
      { pattern: /JUN[1I][0O]/gi, replacement: "JUNIO" },
      // Julio
      { pattern: /JUL[1I][0O]/gi, replacement: "JULIO" },
      // Agosto
      { pattern: /AG[0O]ST[0O]/gi, replacement: "AGOSTO" },
      { pattern: /AG[0O]/gi, replacement: "AGO" },
      // Septiembre
      { pattern: /S[3E]PT[1I][3E]MBR[3E]/gi, replacement: "SEPTIEMBRE" },
      { pattern: /S[3E]P/gi, replacement: "SEP" },
      // Octubre
      { pattern: /[0O]CTUBR[3E]/gi, replacement: "OCTUBRE" },
      { pattern: /[0O]CT/gi, replacement: "OCT" },
      // Noviembre
      { pattern: /N[0O]V[1I][3E]MBR[3E]/gi, replacement: "NOVIEMBRE" },
      { pattern: /N[0O]V/gi, replacement: "NOV" },
      // Diciembre
      { pattern: /D[1I]C[1I][3E]MBR[3E]/gi, replacement: "DICIEMBRE" },
      { pattern: /D[1I]C/gi, replacement: "DIC" },
    ];

    for (const { pattern, replacement } of monthCorrections) {
      correctedText = correctedText.replace(pattern, replacement);
    }

    return correctedText;
  };

  /**
   * Aplica preprocesamiento a la imagen para mejorar la precisión del OCR
   * - Aumenta el contraste
   * - Convierte a escala de grises
   * - Aplica binarización (threshold)
   * - Aplica sharpening (nitidez)
   */
  const preprocessImageForOcr = (canvas, useBinarization = true) => {
    const context = canvas.getContext("2d");
    const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;

    // Paso 1: Aumentar contraste
    const contrastFactor = 1.7;
    for (let i = 0; i < data.length; i += 4) {
      data[i] = Math.min(
        255,
        Math.max(0, (data[i] - 128) * contrastFactor + 128),
      );
      data[i + 1] = Math.min(
        255,
        Math.max(0, (data[i + 1] - 128) * contrastFactor + 128),
      );
      data[i + 2] = Math.min(
        255,
        Math.max(0, (data[i + 2] - 128) * contrastFactor + 128),
      );
    }

    // Paso 2: Convertir a escala de grises
    for (let i = 0; i < data.length; i += 4) {
      const gray = data[i] * 0.299 + data[i + 1] * 0.587 + data[i + 2] * 0.114;

      if (useBinarization) {
        // Umbral más alto para eliminar bordes de celdas (grises ~150-180) sin perder texto negro
        const threshold = 185;
        const binaryValue = gray > threshold ? 255 : 0;
        data[i] = binaryValue;
        data[i + 1] = binaryValue;
        data[i + 2] = binaryValue;
      } else {
        // Solo escala de grises sin binarización (mejor para texto con diferentes tonos)
        data[i] = gray;
        data[i + 1] = gray;
        data[i + 2] = gray;
      }
    }

    context.putImageData(imageData, 0, 0);
    return canvas;
  };

  const convertPdfToImages = async (file, pageNumbers = null) => {
    try {
      GlobalWorkerOptions.workerSrc = await getPdfWorkerUrl();
      const arrayBuffer = await file.arrayBuffer();
      const pdf = await getDocument({ data: arrayBuffer }).promise;
      const images = [];

      // Escala aumentada para mejor resolución y precisión del OCR
      // (3 equilibra calidad de OCR y velocidad; 4 es ~1.8x más píxeles y más lento)
      const scale = 3;

      const pagesToRender = pageNumbers
        ? pageNumbers.filter((p) => p >= 1 && p <= pdf.numPages)
        : Array.from({ length: pdf.numPages }, (_, i) => i + 1);

      for (const pageNum of pagesToRender) {
        const page = await pdf.getPage(pageNum);
        const viewport = page.getViewport({ scale });

        // Crear DOS versiones de la imagen para mejor cobertura de OCR

        // Versión 1: Con binarización (mejor para texto negro sobre blanco)
        const canvas1 = document.createElement("canvas");
        const context1 = canvas1.getContext("2d");
        canvas1.width = viewport.width;
        canvas1.height = viewport.height;
        context1.fillStyle = "white";
        context1.fillRect(0, 0, canvas1.width, canvas1.height);
        await page.render({ canvasContext: context1, viewport }).promise;
        preprocessImageForOcr(canvas1, true); // Con binarización

        // Versión 2: Sin binarización (mejor para texto gris o con diferentes tonos)
        const canvas2 = document.createElement("canvas");
        const context2 = canvas2.getContext("2d");
        canvas2.width = viewport.width;
        canvas2.height = viewport.height;
        context2.fillStyle = "white";
        context2.fillRect(0, 0, canvas2.width, canvas2.height);
        await page.render({ canvasContext: context2, viewport }).promise;
        preprocessImageForOcr(canvas2, false); // Sin binarización, solo escala de grises

        images.push({
          binarized: canvas1.toDataURL("image/png", 1.0),
          grayscale: canvas2.toDataURL("image/png", 1.0),
          pageNumber: pageNum,
          totalPages: pdf.numPages,
        });
      }
      return images;
    } catch (error) {
      console.log("Error en convertPdfToImages: ");
      console.log(error);
    }
  };

  // Reutiliza un worker ya inicializado: solo cambia el PSM con setParameters,
  // sin recrear el motor ni redescargar el modelo de idioma en cada pasada.
  const getTextFromImage = async (file, worker) => {
    const regexNroFactura = /\d{4,5}\s*[-–—]\s*\d{8,9}/;

    // PSM 3: Segmentación automática (mejor para facturas con múltiples bloques)
    await worker.setParameters({ tessedit_pageseg_mode: "3" });
    let rawText = (await worker.recognize(file)).data.text || "";

    // Único reintento — PSM 11: Sparse text, encuentra texto sin analizar layout
    // (resuelve celdas AFIP). Solo si PSM 3 no detectó el N° de factura.
    if (!regexNroFactura.test(rawText)) {
      console.log("  └─ Reintentando OCR con PSM 11 (sparse)...");
      await worker.setParameters({ tessedit_pageseg_mode: "11" });
      const rawText2 = (await worker.recognize(file)).data.text || "";
      if (regexNroFactura.test(rawText2) || rawText2.length > rawText.length) {
        rawText = rawText2;
      }
    }

    // Aplicar corrección de caracteres comúnmente confundidos
    return postProcessOcrText(rawText);
  };

  const validateOCApl = () => {
    if (!solicitaOrdenCompra) {
      return ""; // Configuración global: no se solicita Orden de Compra
    }
    if (checkOcApl) {
      return ""; // Si marcó "No tengo Órdenes de Compra", no validar
    }
    const nroForArr = requeriment.ocsApl?.nroFor;
    if (nroForArr?.length === 0)
      return 'Complete el número de Órdenes de Compra o tilde la opción "No tengo Órdenes de Compra"';

    const isOnlyNumbersOrHyphen = (str) => /^(?=.*[0-9])[0-9-]+$/.test(str.toString().trim());

    for (const option of nroForArr) {
      if (!isOnlyNumbersOrHyphen(option.value))
        return "Ingrese sólo números en el campo Órdenes de Compra";
    }

    return "";
  };

  const validate = async (newLista) => {
    try {
      let msg = "";
      if (!requeriment.nroCta) {
        return "Debe seleccionar un proveedor";
      }
      if (!requeriment.tDocCodFor)
        return "Debe seleccionar un tipo de comprobante";
      if (requeriment.codOri == "") return "Ingrese el número de comprobante";

      // Validación de fecha
      /* if (
        cliente.toLowerCase().includes("moviport") &&
        requeriment.dateOfIssue
      ) { */
      if (requeriment.dateOfIssue) {
        const fechaActual = new Date();
        fechaActual.setHours(0, 0, 0, 0);
        const fechaEmision = new Date(requeriment.dateOfIssue);
        fechaEmision.setHours(0, 0, 0, 0);

        // Solo validar si la fecha es ANTERIOR a hoy
        if (fechaEmision < fechaActual && !edicion) {
          const diffTime = fechaActual - fechaEmision;
          const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

          if (
            diffDays > 5 &&
            (!usuario.permissionRegTdoc ||
              usuario.permissionRegTdoc?.allowOldDateOfIssue === false)
          ) {
            return "No está permitido cargar facturas con más de 5 días de antigüedad";
          }
        }
      }

      if (requeriment.importe == "")
        return "Complete el importe del comprobante";
      if (!requeriment.moneda || requeriment.moneda == "") {
        return "Debe seleccionar el tipo de moneda";
      }
      if (
        requeriment.moneda &&
        requeriment.moneda !== "PESOS" &&
        (!requeriment.cotizacion || requeriment.cotizacion <= 0)
      ) {
        return "La cotización debe ser mayor a 0";
      }
      if (
        globalSettings.codDim &&
        globalSettings.codDim !== "" &&
        (!subcuentaSelected.subCue || subcuentaSelected.subCue === "")
      ) {
        return "Debe seleccionar una subcuenta";
      }
      if (
        (globalSettings?.empresasReceptoras || []).length > 0 &&
        !requeriment?.empresaReceptora?.cuit
      ) {
        return "Debe seleccionar la empresa receptora";
      }
      if (!checkOcApl) {
        const msgOCApl = validateOCApl();
        if (msgOCApl) return msgOCApl;
      }
      if (requeriment.quantity == 0)
        return "Debe ingresar al menos un producto/servicio";
      let control = 0;
      for (const item of newLista) {
        if (item.quantity === 0) {
          control = 1;
        }
      }
      if (control === 1) {
        return "Existe un item sin cantidad asignada";
      }
      if (selectedFiles.length < 1) return "Debe adjuntar un archivo";
      if (edicion !== "Edicion") {
        const respTDoc = await getTDocsByCodForAndCodOriAndNroCta(
          requeriment.tDocCodFor,
          requeriment.codOri,
          requeriment.nroCta,
        );
        let comprobante = null;
        if (respTDoc.data.data) {
          respTDoc.data.data.map((tDoc) => {
            if (tDoc.state !== "RECHAZADO") {
              comprobante = tDoc.codOri;
            }
          });
        }

        if (comprobante)
          return `El número ${comprobante} ya existe para el proveedor y tipo de comprobante seleccionados`;
      }
      return msg;
    } catch (error) {
      console.error("Error durante el proceso de validación:", error);
      throw new Error(
        "Ocurrió un error inesperado durante la validación de los datos. Intente nuevamente.",
        { cause: error },
      );
    }
  };

  const procesarArchivo = async (includeOcr = true, validarFn = null) => {
    setIsModifiedFile(false);

    try {
      console.log("🚀 Iniciando procesamiento de archivo...");
      let file;

      if (edicion === "Edicion" && isModifiedOriginalFile === false) {
        console.log("📥 Descargando archivo desde servidor...");
        const extensionMimeType = getMimeTypeByExtension(selectedFiles[0].name);
        const response = await downloadFile(selectedFiles[0].name);
        const blob = new Blob([response.data], { type: extensionMimeType });
        file = new File([blob], selectedFiles[0].name, {
          type: extensionMimeType,
        });

        const objectUrl = URL.createObjectURL(file);
        URL.revokeObjectURL(objectUrl);
      } else {
        file = selectedFiles[0];
      }

      console.log(
        `📄 Archivo: ${file.name} (${file.type}, ${(file.size / 1024).toFixed(2)} KB)`,
      );

      let fullText = "";

      if (file.type === "application/pdf") {
        console.log("📄 Procesando PDF...");

        try {
          // ESTRATEGIA COMBINADA: Extraer texto nativo + OCR para máxima cobertura

          // 1. Intentar extraer texto nativo del PDF (funciona bien con PDFs digitales de AFIP)
          console.log("  └─ Extrayendo texto nativo del PDF...");
          let nativeText = "";
          try {
            nativeText = await extractTextFromPdf(file);
            console.log(
              `     ✓ Texto nativo: ${nativeText?.length || 0} caracteres`,
            );
          } catch (nativeError) {
            console.log(
              "     ⚠ No se pudo extraer texto nativo:",
              nativeError.message,
            );
          }

          if (!includeOcr) {
            // Modo rápido: solo texto nativo, sin OCR
            console.log("     ✓ Modo rápido: usando solo texto nativo");
            fullText = nativeText || "";
          } else {
            // Verificar si el texto nativo pasa las validaciones antes de recurrir al OCR
            const validationResult = validarFn ? await validarFn(nativeText) : null;

            if (validationResult && validationResult.msg === "") {
              // Texto nativo pasó todas las validaciones: omitir OCR
              console.log("     ✓ Texto nativo pasó validaciones, omitiendo OCR");
              fullText = nativeText;
            } else {
              // Texto nativo insuficiente o falló validación: hacer OCR y combinar
              console.log("  └─ Texto nativo falló validación, procesando con OCR...");
              const ocrText = await performOcrOnPdf(file);
              console.log(`     ✓ OCR: ${ocrText?.length || 0} caracteres`);

              const tieneFacturaNativo = /\d{4,5}\s*[-–—]\s*\d{6,8}/.test(nativeText);
              const tieneFacturaOcr = /\d{4,5}\s*[-–—]\s*\d{6,8}/.test(ocrText);

              if (tieneFacturaNativo && !tieneFacturaOcr) {
                console.log("     ℹ Combinando texto nativo (tiene nro factura) con OCR");
                fullText = `${nativeText}\n\n--- TEXTO OCR ---\n${ocrText}`;
              } else if (nativeText && nativeText.length > ocrText.length * 0.5) {
                console.log("     ℹ Combinando texto nativo con OCR");
                fullText = `${nativeText}\n\n--- TEXTO OCR ---\n${ocrText}`;
              } else {
                fullText = ocrText;
              }
            }
          }
        } catch (error) {
          console.error("  └─ ❌ Error procesando PDF:", error);
          throw error;
        }
      } else if (file.type.startsWith("image/")) {
        console.log("🖼️ Procesando imagen con OCR...");
        const imgWorker = await Tesseract.createWorker("spa+eng", 1, {
          langPath: "https://tessdata.projectnaptha.com/4.0.0",
        });
        await imgWorker.setParameters({ preserve_interword_spaces: "1" });
        try {
          fullText = await getTextFromImage(file, imgWorker);
        } finally {
          await imgWorker.terminate();
        }
        console.log(`✓ OCR completado: ${fullText?.length || 0} caracteres`);
      } else {
        throw new Error(`Tipo de archivo no soportado: ${file.type}`);
      }

      // Validación final
      if (!fullText || fullText.trim().length === 0) {
        console.error("❌ No se pudo extraer texto del archivo");
        throw new Error("No se pudo extraer texto del archivo");
      }

      console.log(`✅ Procesamiento completado: ${fullText.length} caracteres`);
      console.log(`📝 Vista previa:\n${fullText}`);

      setText(fullText);
      return fullText;
    } catch (error) {
      setProcessingPDF(false);
      console.error("❌ Error procesando el archivo:", error);
      throw new Error(`Error procesando el archivo: ${error.message}`, {
        cause: error,
      });
    }
  };

  /**
   * Extrae un crop del área superior-derecha de una imagen (donde está el N° de comprobante AFIP)
   * y corre OCR sobre ese crop con mayor zoom efectivo.
   */
  const getOcrFromHeaderCrop = async (imageDataUrl, worker) => {
    try {
      const img = new Image();
      await new Promise((resolve, reject) => {
        img.onload = resolve;
        img.onerror = reject;
        img.src = imageDataUrl;
      });

      // El encabezado AFIP con el N° de comprobante siempre está en el cuadrante top-right:
      // X: 40% → 100% del ancho   |   Y: 0% → 22% de la altura
      const cropX = Math.floor(img.width * 0.40);
      const cropY = 0;
      const cropW = img.width - cropX;
      const cropH = Math.floor(img.height * 0.22);

      // Escalar el crop 2x para aumentar la resolución efectiva sobre esa zona
      const scale = 2;
      const cropCanvas = document.createElement("canvas");
      cropCanvas.width = cropW * scale;
      cropCanvas.height = cropH * scale;
      const ctx = cropCanvas.getContext("2d");
      ctx.imageSmoothingEnabled = false;
      ctx.drawImage(
        img,
        cropX, cropY, cropW, cropH,
        0, 0, cropW * scale, cropH * scale,
      );

      // Bloque uniforme: mejor para la franja del encabezado
      await worker.setParameters({ tessedit_pageseg_mode: "6" });
      const data = await worker.recognize(cropCanvas.toDataURL("image/png"));
      return data.data.text || "";
    } catch {
      return "";
    }
  };

  const performOcrOnPdf = async (file) => {
    const regexFactura = /\d{4,5}\s*[-–—]\s*\d{6,8}/;
    const regexFacturaEstricta = /\d{4,5}\s*[-–—]\s*\d{8,9}/;

    // Un único worker para todas las pasadas (modelos _fast = más rápidos que _best).
    // OEM 1 (LSTM puro) se pasa como 2º argumento de createWorker.
    const worker = await Tesseract.createWorker("spa+eng", 1, {
      langPath: "https://tessdata.projectnaptha.com/4.0.0",
    });
    await worker.setParameters({ preserve_interword_spaces: "1" });

    const ocrPageImages = async (imageData) => {
      console.log(`  └─ OCR página ${imageData.pageNumber}...`);

      // Se procesa primero solo la imagen en escala de grises (más rápido).
      // La binarizada solo se usa como respaldo si grises no detecta el N° de factura.
      console.log(`     └─ Procesando imagen en escala de grises...`);
      const textGrayscale = await getTextFromImage(imageData.grayscale, worker);

      let pageText = textGrayscale;

      if (!regexFactura.test(textGrayscale)) {
        console.log(`     └─ Grises sin N° de factura, probando imagen binarizada...`);
        const textBinarized = await getTextFromImage(imageData.binarized, worker);

        if (
          regexFactura.test(textBinarized) ||
          textBinarized.length > textGrayscale.length
        ) {
          pageText = textBinarized;
        }

        // Si ninguna versión detectó el N° de factura, combinar ambas para no perder texto
        if (!regexFactura.test(pageText) && (textBinarized || textGrayscale)) {
          pageText = `${textBinarized}\n${textGrayscale}`;
        }
      }

      if (!regexFacturaEstricta.test(pageText)) {
        console.log(`     └─ OCR sobre crop del encabezado AFIP...`);
        const headerText = await getOcrFromHeaderCrop(imageData.grayscale, worker);
        if (headerText) {
          console.log(`        ✓ Encabezado: ${headerText.trim().replace(/\n/g, " ")}`);
          pageText = `${headerText}\n${pageText}`;
        }
      }

      return pageText;
    };

    try {
      // Procesar solo página 1 primero
      const page1Images = await convertPdfToImages(file, [1]);
      if (!page1Images || page1Images.length === 0) return "";

      const totalPages = page1Images[0].totalPages;
      console.log(
        `  └─ Convirtiendo a imágenes: solo página 1 (el PDF tiene ${totalPages} página(s) en total)`,
      );

      const page1Text = await ocrPageImages(page1Images[0]);
      let ocrText = page1Text?.trim()
        ? `\n--- PÁGINA 1 ---\n${page1Text}`
        : `\n--- PÁGINA 1 ---\n[Sin texto legible]`;

      if (page1Text?.trim()) {
        console.log(`     ✓ ${page1Text.length} caracteres extraídos`);
      } else {
        console.log(`     ⚠ Página sin texto legible`);
      }

      // El OCR por imagen procesa únicamente la página 1, aunque el PDF tenga más páginas
      if (totalPages > 1) {
        console.log(`     ℹ El PDF tiene ${totalPages} páginas; OCR aplicado solo a la página 1`);
      }

      return ocrText;
    } finally {
      // Libera el motor WASM y su memoria una vez procesado el archivo
      await worker.terminate();
    }
  };

  const validateValoresArchivo = async (
    {
      flagImporteChecked = false,
      flagCuitEmisorChecked = false,
      flagFechaChecked = false,
      flagCuitReceptorChecked = false,
      flagNroFacturaChecked = false,
    },
    text = {},
  ) => {
    try {
      let flagCuitReceptor;
      let flagImporte;
      let flagCuitEmisor;
      let flagNroFactura;
      let flagFecha;
      const textNormalized = text.replace(/\s+/g, "");
      let lines = text.split("\n");

      const empresasReceptoras = globalSettings?.empresasReceptoras || [];
      // Si hay empresa receptora seleccionada, validamos ese CUIT específico;
      // si no, probamos cualquiera de la lista; si la lista está vacía, fallback al CUIT único.
      const cuitsAValidar =
        requeriment?.empresaReceptora?.cuit
          ? [requeriment.empresaReceptora.cuit]
          : empresasReceptoras.length > 0
          ? empresasReceptoras.map((e) => e.cuit)
          : [globalSettings?.companyCuit || licencia.cuit].filter(Boolean);

      for (const cuitEmpresa of cuitsAValidar) {
        if (!cuitEmpresa) continue;
        const cuitReceptorFormateadoGuiones = formatCuitGuiones(cuitEmpresa);
        const cuitReceptorFormateadoPuntos = formatCuitPuntos(cuitEmpresa);
        const cuitReceptorFormateadoGuionPunto = formatCuitGuionPunto(cuitEmpresa);
        const cuitReceptorFormateadoPuntoGuion = formatCuitPuntoGuion(cuitEmpresa);

        if (
          text.includes(cuitEmpresa) ||
          text.includes(cuitReceptorFormateadoGuiones) ||
          text.includes(cuitReceptorFormateadoPuntos) ||
          text.includes(cuitReceptorFormateadoGuionPunto) ||
          text.includes(cuitReceptorFormateadoPuntoGuion)
        ) {
          flagCuitReceptor = true;
          break;
        }
      }

      if (requeriment.cuitProv) {
        // Formatear CUIT con guiones: XX-XXXXXXXX-X
        const cuitEmisorFormateadoGuiones = formatCuitGuiones(
          requeriment.cuitProv,
        );
        // Formatear CUIT con guiones: XX.XXXXXXXX.X
        const cuitEmisorFormateadoPuntos = formatCuitPuntos(
          requeriment.cuitProv,
        );
        // Formatear CUIT con guiones: XX-XXXXXXXX.X
        const cuitEmisorFormateadoGuionPunto = formatCuitGuionPunto(
          requeriment.cuitProv,
        );
        // Formatear CUIT con guiones: XX.XXXXXXXX-X
        const cuitEmisorFormateadoPuntoGuion = formatCuitPuntoGuion(
          requeriment.cuitProv,
        );
        if (
          text.includes(requeriment.cuitProv) ||
          text.includes(cuitEmisorFormateadoGuiones) ||
          text.includes(cuitEmisorFormateadoPuntos) ||
          text.includes(cuitEmisorFormateadoGuionPunto) ||
          text.includes(cuitEmisorFormateadoPuntoGuion)
        ) {
          flagCuitEmisor = true;
        }
      }

      if (lines.length > 0 && requeriment.codOri) {
        const ptoVenta = requeriment.codOri?.split("-")[0];
        const nroFactura = requeriment.codOri?.split("-")[1];

        // Normalizar ptoVenta y nroFactura: eliminar ceros a la izquierda
        const ptoVentaNormalizado = ptoVenta?.replace(/^0+/, "");
        const nroFacturaNormalizado = nroFactura?.replace(/^0+/, "");

        let lineaNroFactura = null;
        for (const line of lines) {
          // Primero verificar si la línea contiene el nroFactura (original o normalizado)
          const contieneNroFactura =
            line.includes(nroFactura) ||
            (nroFacturaNormalizado && line.includes(nroFacturaNormalizado));

          if (contieneNroFactura) {
            // Verificar si también contiene el ptoVenta (en cualquier formato)
            const contienePtoVenta =
              line.includes(ptoVenta) ||
              (ptoVentaNormalizado && line.includes(ptoVentaNormalizado));

            if (contienePtoVenta) {
              lineaNroFactura = line;
              break;
            }
          }
        }
        flagNroFactura = !!lineaNroFactura;
      }

      if (requeriment.dateOfIssue) {
        // Buscar con formatos numéricos (DD/MM/YYYY, etc.)
        const fechaEncontradaNumerica = formatosFecha.some((format) =>
          textNormalized.includes(
            moment(requeriment.dateOfIssue).format(format),
          ),
        );

        if (fechaEncontradaNumerica) {
          flagFecha = true;
        } else {
          // Buscar con nombres de meses (Ene, Enero, etc.)
          const fechasConNombreMes = generarFechasConNombreMes(
            requeriment.dateOfIssue,
          );
          const textSinEspacios = textNormalized.toLowerCase().replace(/\s+/g, "");
          const fechaEncontradaConMes = fechasConNombreMes.some(
            (fechaVariante) =>
              textSinEspacios.includes(fechaVariante.toLowerCase().replace(/\s+/g, "")),
          );

          if (fechaEncontradaConMes) {
            flagFecha = true;
          }
        }
      }

      if (requeriment.importe) {
        const importe = parseFloat(requeriment.importe); // Convertir a número

        if (!isNaN(importe)) {
          // 1. PrimerFormato: 1,000.01 → inglés (US)
          const primerFormatoImporte = getMontoPrimerFormato(importe);

          // 2. SegundoFormato: 1.000,01 → español (Argentina o Europa)
          const segundoFormatoImporte = getMontoSegundoFormato(importe);

          // 3. TercerFormato: 1000.01 → sin separadores, con punto decimal
          const tercerFormatoImporte = getMontoTercerFormato(importe);

          // 4. CuartoFormato: 1000,01 → sin separadores, con coma decimal
          const cuartoFormatoImporte = getMontoCuartoFormato(importe);

          if (
            text.includes(primerFormatoImporte) ||
            text.includes(segundoFormatoImporte) ||
            text.includes(tercerFormatoImporte) ||
            text.includes(cuartoFormatoImporte)
          ) {
            flagImporte = true;
          } else {
            // 5. Si no se encontró en formatos numéricos, buscar en letras
            const importeEnLetras = getMontoEnLetras(importe);
            const palabrasImporte = importeEnLetras.toLowerCase().split(/\s+/);
            const textLower = text.toLowerCase();

            // Verificar si todas las palabras del importe en letras están en el texto
            const todasLasPalabrasPresentes = palabrasImporte.every((palabra) =>
              textLower.includes(palabra),
            );

            if (todasLasPalabrasPresentes) {
              flagImporte = true;
            }
          }
        }
      }

      if (!flagCuitReceptor && !flagCuitReceptorChecked) {
        const cuitMsg = requeriment?.empresaReceptora?.cuit
          || globalSettings?.companyCuit
          || licencia.cuit;
        const nombreMsg = requeriment?.empresaReceptora?.razonSocial
          || globalSettings?.companyName
          || licencia.nombre;
        return {
          msg: `En el archivo no se encuentra el C.U.I.T ${cuitMsg} de ${nombreMsg} como empresa receptora.`,
          isBlocking: false,
          capturedObservationMsg: "cuitReceptor",
          flagCuitReceptorChecked: true,
          flagImporteChecked: flagImporteChecked,
          flagCuitEmisorChecked: flagCuitEmisorChecked,
          flagFechaChecked: flagFechaChecked,
          flagNroFacturaChecked: flagNroFacturaChecked,
        };
      }
      if (!flagCuitEmisor && !flagCuitEmisorChecked) {
        return {
          msg: "El cuit del proveedor seleccionado no concuerda con el especificado en el archivo.",
          isBlocking: false,
          capturedObservationMsg: "cuitEmisor",
          flagCuitReceptorChecked: flagCuitReceptorChecked,
          flagCuitEmisorChecked: true,
          flagImporteChecked: flagImporteChecked,
          flagFechaChecked: flagFechaChecked,
          flagNroFacturaChecked: flagNroFacturaChecked,
        };
      }
      if (!flagNroFactura && !flagNroFacturaChecked) {
        return {
          msg: "El número de comprobante ingresado no concuerda con el especificado en el archivo.",
          capturedObservationMsg: "nroFactura",
          isBlocking: true, // BLOQUEANTE
          flagCuitReceptorChecked: flagCuitReceptorChecked,
          flagCuitEmisorChecked: flagCuitEmisorChecked,
          flagNroFacturaChecked: true,
          flagImporteChecked: flagImporteChecked,
          flagFechaChecked: flagFechaChecked,
        };
      }
      if (!flagFecha && !flagFechaChecked) {
        return {
          msg: "La fecha de emisión ingresada no concuerda con la especificada en el archivo.",
          isBlocking: true, // BLOQUEANTE
          capturedObservationMsg: "fecha",
          flagCuitReceptorChecked: flagCuitReceptorChecked,
          flagCuitEmisorChecked: flagCuitEmisorChecked,
          flagNroFacturaChecked: flagNroFacturaChecked,
          flagFechaChecked: true,
          flagImporteChecked: flagImporteChecked,
        };
      }
      if (!flagImporte && !flagImporteChecked) {
        return {
          msg: "El importe ingresado no concuerda con el especificado en el archivo.",
          isBlocking: false,
          capturedObservationMsg: "importe",
          flagCuitReceptorChecked: flagCuitReceptorChecked,
          flagCuitEmisorChecked: flagCuitEmisorChecked,
          flagNroFacturaChecked: flagNroFacturaChecked,
          flagFechaChecked: flagFechaChecked,
          flagImporteChecked: true,
        };
      } else {
        return { msg: "" };
      }
    } catch (error) {
      console.error(
        "Error durante la validación de valores del archivo:",
        error,
      );

      throw new Error(
        "Ocurrió un error al validar la información del archivo adjunto. Por favor, intente nuevamente.",
        { cause: error },
      );
    }
  };

  const handleSaveRequirement = async (
    validationObj = {
      flagCuitEmisorChecked: false,
      flagCuitReceptor: false,
      flagNroFactura: false,
      flagFecha: false,
      flagImporte: false,
    },
    remitosOverride = null,
    nroForOverride = null,
  ) => {
    setControlBotonEnviar(true); // Bloqueo el botón mientras se esta enviando el comprobante.

    const canBypassBlockingError = (msgObject) => {
      if (!msgObject.isBlocking) return true;

      const perms = usuario.permissionRegTdoc;
      if (!perms?.notRestrictions) return false;

      return (
        (perms.allowInvalidNroCodOri &&
          msgObject.capturedObservationMsg === "nroFactura") ||
        (perms.allowInvalidDateOfIssue &&
          msgObject.capturedObservationMsg === "fecha")
      );
    };

    const showConfirmWarning = (msg) =>
      Swal.fire({
        title: "Ops!",
        icon: "warning",
        text: msg + "Esta seguro que desea guardar el comprobante?",
        showConfirmButton: true,
        showCancelButton: true, // Habilita el botón de cancelar
        confirmButtonColor: "#ff0000",
        denyButtonColor: "#3d4d87",
        confirmButtonText: "Sí, estoy seguro",
        cancelButtonText: "No",
        allowEnterKey: true,
      });

    const showBlockingError = async (msg) => {
      await Swal.fire({
        title: "No se puede guardar",
        icon: "error",
        text: msg,
        confirmButtonText: "Aceptar",
      });
    };

    try {
      const newLista = items.filter((d) => d.artCod !== "");
      let validation = await validate(newLista);
      if (validation == "") {
         // Si la extracción por IA NO está activa y no está tildado el check "Guardar sin validar adjunto", ejecutar validación OCR del archivo
         if (!skipValidation && !aiExtractionEnabled) {
          setProcessingPDF(true);

          // Paso 1: Extraer solo texto nativo (rápido, sin OCR)
          const nativeText = text && !isModifiedFile
            ? text
            : await procesarArchivo(false);

          // Paso 2: Validar con texto nativo
          const nativeMsgObject = nativeText
            ? await validateValoresArchivo(validationObj, nativeText)
            : null;

          if (nativeMsgObject && nativeMsgObject.msg === "") {
            // Texto nativo pasa todas las validaciones → guardar sin OCR
            console.log("✓ Texto nativo pasó validaciones, omitiendo OCR");
            setProcessingPDF(false);
          } else {
            // Texto nativo insuficiente o falló validación → lanzar OCR para mayor cobertura
            console.log("ℹ Texto nativo falló validación, lanzando OCR...");
            const numPagesPdf = (nativeText?.match(/--- PAGE \d+ ---/g) || []).length || 3;
            const TIMEOUT_OCR_MS = numPagesPdf * 1 * 60 * 1000;
            const textArchivo = await Promise.race([
              procesarArchivo(true, (texto) => validateValoresArchivo(validationObj, texto)),
              new Promise((resolve) =>
                setTimeout(() => resolve(null), TIMEOUT_OCR_MS),
              ),
            ]);
            setProcessingPDF(false);

            if (textArchivo === null) {
              console.warn(
                "⚠ Timeout OCR: no se pudo procesar el archivo por baja calidad de imagen.",
              );
              if (isAdminOrControl) {
                const result = await showConfirmWarning(
                  "No se pudo validar el archivo adjunto por baja calidad de imagen. ",
                );
                if (result.isConfirmed) {
                  observadaRef.current = true;
                  msgsObservadaRef.current.nroFactura =
                    "No se pudo validar el archivo por baja calidad de imagen.";
                } else {
                  setControlBotonEnviar(false);
                  return;
                }
              } else {
                await Swal.fire({
                  title: "No se pudo validar el archivo",
                  text: "No se pudo validar el archivo adjunto por baja calidad de imagen.",
                  icon: "error",
                  confirmButtonText: "Aceptar",
                });
                setControlBotonEnviar(false);
                return;
              }
            }

            let msgObject =
              textArchivo !== null
                ? await validateValoresArchivo(validationObj, textArchivo)
                : { msg: "" };

            if (msgObject.msg != "") {
              if (!canBypassBlockingError(msgObject)) {
                await showBlockingError(msgObject.msg);
                setControlBotonEnviar(false);
                return;
              }
              const result = await showConfirmWarning(msgObject.msg);

              const { msg, capturedObservationMsg, ...validationValoresArchivo } =
                msgObject;

              const updateObservation = (type, isConfirmed) => {
                observadaRef.current = isConfirmed;
                const propertyName = type;
                msgsObservadaRef.current[propertyName] = isConfirmed ? msg : "";
              };

              if (result.isConfirmed) {
                updateObservation(capturedObservationMsg, true);
                await handleSaveRequirement(validationValoresArchivo);
              } else {
                updateObservation("cuitReceptor", false);
                updateObservation("cuitEmisor", false);
                updateObservation("nroFactura", false);
                updateObservation("fecha", false);
                updateObservation("importe", false);
                setControlBotonEnviar(false);
              }
              return;
            }
          }
        }

        {
          const getDatosObservacion = () => ({
            observada: observadaRef.current,
            motivoObserv: [
              msgsObservadaRef.current.cuitReceptor,
              msgsObservadaRef.current.cuitEmisor,
              msgsObservadaRef.current.nroFactura,
              msgsObservadaRef.current.fecha,
              msgsObservadaRef.current.importe,
            ]
              .filter(Boolean)
              .join(" | "),
          });

          // Preparar conceptos para guardar (todos, con o sin ERP)
          const conceptosParaGuardar = conceptos.map((c) => ({
            description: c.description,
            quantity: c.quantity,
            unitPrice: c.unitPrice,
            amount: c.amount,
            tipPro: c.codigoERP?.tipPro || "",
            artCod: c.codigoERP?.artCod || "",
            codRed: c.codigoERP?.codRed || "",
            descrpERP: c.codigoERP?.descrp || "",
          }));

          const ocsAplParaGuardar = checkOcApl
            ? []
            : (requeriment.ocsApl?.nroFor ? requeriment.ocsApl.nroFor : [])
                .map((option) => ({ nroFor: Number(option.value), remitos: [] }))
                .filter((oc) => !Number.isNaN(oc.nroFor));

          let resp;
          if (edicion === "Edicion") {
            resp = await guardarReq(
              {
                ...requeriment,
                ocsApl: ocsAplParaGuardar,
                codDim: subcuentaSelected.codDim,
                codDimDescrp: subcuentaSelected.codDimDescrp,
                subCue: subcuentaSelected.subCue,
                subCueDescrp: subcuentaSelected.subCueDescrp,
                ...getDatosObservacion(),
              },
              newLista,
              selectedFiles,
              conceptosParaGuardar,
              aditionalDocs
            );
            setControlBotonEnviar(false); // Habilitar el botón nuevamente
            cerrar();
          } else {
            resp = await guardarReq(
              {
                ...requeriment,
                ocsApl: ocsAplParaGuardar,
                codDim: subcuentaSelected.codDim,
                codDimDescrp: subcuentaSelected.codDimDescrp,
                subCue: subcuentaSelected.subCue,
                subCueDescrp: subcuentaSelected.subCueDescrp,
                ...getDatosObservacion(),
              },
              newLista,
              selectedFiles,
              conceptosParaGuardar,
              aditionalDocs
            );
            if (resp && edicion !== "Edicion") {
              setRequeriment(
                isProfileProv
                  ? {
                      ...req,
                      codOri: "",
                      importe: "",
                      nroCta: usuario.nroCta,
                      nroCtaDescrp: usuario.fullName,
                    }
                  : { ...req, codOri: "", importe: "" },
              );
              setPtoVentaComprobante("");
              setNroComprobante("");
              setSelectedFiles(files);
              setItems([estructura_producto]);
              setConceptos([]);
            }
            navigate("/Home");
          }
        }
      } else {
        setControlBotonEnviar(false); // Habilitar el botón nuevamente
        Swal.fire({
          title: "Hubo un error en la validación!",
          text: validation,
          icon: "error",
        });
      }
    } catch (error) {
      await Swal.fire({
        title: error?.swalTitle || "Error al guardar el comprobante",
        text:
          error?.response?.data?.message ||
          error?.message ||
          "Ocurrió un error inesperado",
        icon: error?.swalIcon || "error",
      });
      // Solo cierro el modal cuando el comprobante sí se guardó y fallaron los adicionales
      // (en la vista /addReq no hay modal, por eso "cerrar" puede no venir)
      if (error?.swalTitle === "Documentos adicionales" && cerrar) {
        cerrar();
      }
    } finally {
      setControlBotonEnviar(false);
    }
  };

  const eliminaFile = (aborrar) => {
    const array = Array.from(selectedFiles);
    setSelectedFiles(array.filter((data) => data.name !== aborrar.name));
  };

  const cambioColorSeleccion = () => {
    setSelectionColor(!selectionColor);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name == "ocsApl") {
      const numericValue = value.replace(/\D/g, "");
      setRequeriment({
        ...requeriment,
        ocsApl: {
          ...requeriment.ocsApl,
          nroFor: numericValue === "" ? null : Number(numericValue), // importante convertir a número
        },
      });
    } else {
      setRequeriment({ ...requeriment, [name]: value });
    }
  };

  const handleChangeOcApl = (selectedOptions) => {
    setRequeriment((prev) => ({
      ...prev,
      ocsApl: {
        ...prev.ocsApl,
        nroFor: selectedOptions || [],
      },
    }));
  };

  const handleDropAditionalDocs = (e) => {
    e.preventDefault();
    e.stopPropagation();
    delete e.currentTarget.dataset.dragging;
    addAditionalDocs(Array.from(e.dataTransfer.files));
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    delete e.currentTarget.dataset.dragging;
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.dataset.dragging = "true";
  };

  const handleChangeAditionalDocs = (e) => {
    e.preventDefault();
    addAditionalDocs(Array.from(e.target.files));
  };

  const addAditionalDocs = (docs) => {
    let newDocs = docs.map((d) => {
      return { name: d.name, type: d.type, size: d.size, file: d, action: "ADD" };
    });
    setAditionalDocs((prevDocs) => (prevDocs ? [...prevDocs, ...newDocs] : [...newDocs]));
  };

  const deleteAditionalDoc = (id) => {
    setAditionalDocs((prevDocs) =>
      prevDocs
        .map((d, i) => {
          if (i != id) return d;
          // Si ya estaba guardado en S3 lo marco para eliminar (action DELETE);
          // si era nuevo (aún no subido) simplemente lo descarto.
          return d.action === "SAVED" ? { ...d, action: "DELETE" } : null;
        })
        .filter(Boolean)
    );
  };

  const handlerClickNotOc = (bool) => {
    // Hacer blur del input antes de procesar
    const inputOcApl = document.getElementById("inputOcApl");

    if (bool === true) {
      setRequeriment((prev) => ({
        ...prev,
        ocsApl: {
          nroFor: [],
        },
      }));
      setcheckOcApl(true);
    } else {
      setcheckOcApl(false);
      setRequeriment((prev) => ({
        ...prev,
        ocsApl: {
          nroFor: [],
        },
      }));
    }
  };

  if (loading) {
    return (
      <div
        className="container-gr-addreq"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
      </div>
    );
  } else {
    return (
      <div className="container-gr-addreq">
        <div className="header-ocultar-controles">
          <div className="header-campo-inline header-campo-prov">
            <SelectList
              text={requeriment.cuitProv ? `Proveedor — CUIT: ${requeriment.cuitProv}` : "Proveedor"}
              options={proveedoresActivos.map((p) => {
                return {
                  value: `${p.nroCta}`,
                  label: `${p.nroCta} - ${p.nombre}`,
                };
              })}
              handleChange={handleChangeProveedor}
              property={"Proveedor"}
              valueAux={{
                label:
                  requeriment.nroCtaDescrp && requeriment.nroCta
                    ? `${requeriment.nroCta} - ${requeriment.nroCtaDescrp}`
                    : "Seleccione...",
                value: requeriment.nroCta || "",
              }}
              disabled={edicion === "Edicion" ? true : isProfileProv}
              emptyInputs={[]}
              styles={{
                additionalStyleDivSelectList: {
                  alignItems: "left",
                },
                fontStyleTitle: {
                  fontWeight: "bold",
                  fontSize: "14px",
                  color: "#7c7b7b",
                },
              }}
              fontBold={true}
            />
          </div>
          <div className="header-campo-inline header-campo-tipo">
            <SelectList
              text={"Tipo Comprob."}
              options={tiposComprobantes.map((tC) => {
                return {
                  value: `${tC.tipo}`,
                  label: `${tC.tipo} - ${tC.descripcion}`,
                };
              })}
              handleChange={handleChangeTipoComprobante}
              property={"Tipo de Comprobante"}
              valueAux={{
                label:
                  requeriment.tDocCodFor && requeriment.tDocCodForDescrp
                    ? `${requeriment.tDocCodFor} - ${requeriment.tDocCodForDescrp}`
                    : "Seleccione...",
                value: requeriment.tDocCodFor || "",
              }}
              disabled={edicion === "Edicion" ? true : false}
              emptyInputs={[]}
              styles={{
                additionalStyleDivSelectList: {
                  alignItems: "left",
                },
                fontStyleTitle: {
                  fontWeight: "bold",
                  fontSize: "14px",
                  color: "#7c7b7b",
                },
              }}
              fontBold={true}
            />
          </div>
          <div className="header-campo-inline header-campo-nrofac">
            <label className="header-campo-label">Nro. Factura</label>
            <div className="header-nrofac-inputs">
              <input
                placeholder={
                  ENTORNO.toLowerCase().includes("solimeno") ? "0000" : "00000"
                }
                name="ptoVenta"
                value={ptoVentaComprobante}
                onChange={handleChangePtoVenta}
                onBlur={handleBlurPtoVenta}
                autoFocus={true}
                className="header-nrofac-input"
                maxLength={5}
              />
              <span className="header-nrofac-sep">-</span>
              <input
                placeholder="00000000"
                name="nroComprobante"
                value={nroComprobante}
                onChange={handleChangeNroComprobante}
                onBlur={handleBlurNroComprobante}
                className="header-nrofac-input header-nrofac-input-wide"
                maxLength={8}
              />
            </div>
          </div>
          <button
            className="ocultarControlesBtn"
            onClick={() => setMostrarControles(!mostrarControles)}
            style={{ marginLeft: "auto" }}
          >
            <FontAwesomeIcon icon={mostrarControles ? faEyeSlash : faEye} />
            <span>{mostrarControles ? "Ocultar controles" : "Mostrar controles"}</span>
          </button>
          {edicion && (
            <FontAwesomeIcon
              className="header-cerrar-x"
              icon={faXmark}
              onClick={() => cerrar(null)}
            />
          )}
        </div>
        {/* Tabla conceptos visible cuando los controles están ocultos */}
        {!mostrarControles && aiExtractionEnabled && (
          <div className="conceptos-ai-wrapper">
            <div className="conceptos-ai-tabs">
              <button className="conceptos-ai-tab selected">Conceptos</button>
            </div>
            <div className="conceptos-ai-container">
              <div className="conceptos-ai-header">
                <label>Conceptos por Comprobante ({conceptos.length})</label>
              </div>
            <div className="conceptos-ai-items">
              {conceptos.length > 0 && (
                <div className="concepto-item concepto-labels-row">
                  <div className="concepto-row-data">
                    <span className="concepto-num">#</span>
                    <span className="concepto-label concepto-field-desc">Descripción</span>
                    <span className="concepto-label concepto-field-num">Cantidad</span>
                    <span className="concepto-label concepto-field-num">P. Unitario</span>
                    <span className="concepto-label concepto-field-num">Monto</span>
                    {!isUserTypeProv && <span className="concepto-label concepto-erp-inline">Producto ERP</span>}
                    <span className="concepto-label concepto-delete-col"></span>
                  </div>
                </div>
              )}
              {conceptos.map((concepto, idx) => (
                <div className="concepto-item" key={idx}>
                  <div className="concepto-row-data">
                    <span className="concepto-num">{idx + 1}</span>
                    <input
                      className="concepto-field concepto-field-desc"
                      value={concepto.description}
                      disabled
                      title={concepto.description}
                    />
                    <input
                      className="concepto-field concepto-field-num"
                      type="number"
                      value={concepto.quantity}
                      title="Cantidad"
                      onChange={(e) => {
                        const newConceptos = [...conceptos];
                        const val = e.target.value === "" ? "" : Number(e.target.value);
                        newConceptos[idx] = { ...newConceptos[idx], quantity: val };
                        setConceptos(newConceptos);
                      }}
                    />
                    <input
                      className="concepto-field concepto-field-num"
                      type="number"
                      value={concepto.unitPrice}
                      title="P. Unitario"
                      onChange={(e) => {
                        const newConceptos = [...conceptos];
                        const val = e.target.value === "" ? "" : Number(e.target.value);
                        newConceptos[idx] = { ...newConceptos[idx], unitPrice: val };
                        setConceptos(newConceptos);
                      }}
                    />
                    <input
                      className="concepto-field concepto-field-num concepto-field-total"
                      type="number"
                      value={concepto.amount}
                      title="Monto"
                      onChange={(e) => {
                        const newConceptos = [...conceptos];
                        const val = e.target.value === "" ? "" : Number(e.target.value);
                        newConceptos[idx] = { ...newConceptos[idx], amount: val };
                        setConceptos(newConceptos);
                      }}
                    />
                    {!isUserTypeProv && <div className="concepto-erp-inline">
                      <AutocompleteV2
                        placeholder="Producto ERP"
                        value={
                          concepto.codigoERP
                            ? `${concepto.codigoERP.tipPro}${concepto.codigoERP.artCod} - ${concepto.codigoERP.descrp} (${concepto.codigoERP.codRed})`
                            : ""
                        }
                        setValue={(val) => {
                          const newConceptos = [...conceptos];
                          if (val && val.includes(" - ")) {
                            const codeStr = val.split(" - ")[0].trim();
                            const prod = productListActivos.find(
                              (p) => `${p.tipPro}${p.artCod}`.replace(/\s+/g, '') === codeStr.replace(/\s+/g, '')
                            );
                            if (prod) {
                              newConceptos[idx] = {
                                ...newConceptos[idx],
                                codigoERP: {
                                  tipPro: prod.tipPro || "",
                                  artCod: prod.artCod || "",
                                  codRed: prod.codRed || "",
                                  descrp: prod.descrp || "",
                                },
                              };
                            }
                          } else {
                            newConceptos[idx] = {
                              ...newConceptos[idx],
                              codigoERP: null,
                            };
                          }
                          setConceptos(newConceptos);
                        }}
                        dataSuggestions={productListActivos.map((p) => ({
                          code: `${p.tipPro}${p.artCod}`,
                          descrp: `${p.descrp} (${p.codRed})`,
                        }))}
                        ocpsRecuperadas={true}
                        width="100%"
                        height="34px"
                      />
                    </div>}
                    <button
                      className="concepto-delete-btn"
                      title="Eliminar concepto"
                      onClick={() => {
                        setConceptos(conceptos.filter((_, i) => i !== idx));
                      }}
                    >
                      ✕
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        )}
        {mostrarControles && <>
        {(globalSettings?.empresasReceptoras || []).length > 0 && (
          <div className="container-empresa-receptora">
            <SelectList
              text={"Empresa Receptora"}
              options={(globalSettings?.empresasReceptoras || []).map((e) => ({
                value: `${e.cuit}`,
                label: `${e.cuit}${e.razonSocial ? ` - ${e.razonSocial}` : ""}`,
              }))}
              handleChange={handleChangeEmpresaReceptora}
              property={"Empresa Receptora"}
              valueAux={{
                label: requeriment?.empresaReceptora?.cuit
                  ? `${requeriment.empresaReceptora.cuit}${
                      requeriment.empresaReceptora.razonSocial
                        ? ` - ${requeriment.empresaReceptora.razonSocial}`
                        : ""
                    }`
                  : "Seleccione...",
                value: requeriment?.empresaReceptora?.cuit || "",
              }}
              emptyInputs={[]}
              styles={{
                additionalStyleDivSelectList: {
                  alignItems: "left",
                },
                fontStyleTitle: {
                  fontWeight: "bold",
                  fontSize: "14px",
                  color: "#7c7b7b",
                },
              }}
              fontBold={true}
            />
          </div>
        )}
        <div className="container-AddReq-item-gral">
          <div className="subContainer-AddReq-item-gral">
            <div className="container-AddReq-item-details">
              <div className="container-r-item-title-details">
                Fecha de Emisión
              </div>
              <input
                type="date"
                className="label-AddReq-fecha"
                value={moment(requeriment.dateOfIssue).format("YYYY-MM-DD")}
                onChange={(data) => handleChangeDateOfIssue(data.target.value)}
              />
            </div>
            <div className="container-flex-importe-moneda">
              <div className="container-AddReq-item-details">
                <div className="container-r-item-title-details">
                  Importe total
                </div>
                <div
                  className={`bg-white
                  ${
                    onFocus == "importe" ? "inputGroup focused" : "inputGroup"
                  }`}
                >
                  <label onClick={() => importeRef.current.focus()}>$</label>
                  <input
                    onFocus={handleFocusImporte}
                    onBlur={handleBlurImporte}
                    onChange={handleChangeImporte}
                    ref={importeRef}
                    type="text"
                    value={formattedImporte}
                    name="importe"
                    placeholder="0.00"
                    className="label-AddReq-import"
                  />
                </div>
              </div>
              <div className="container-AddReq-item-details">
                <SelectList
                  text={"Moneda"}
                  options={opcionesMoneda.map((o) => {
                    return {
                      value: `${o}`,
                      label: `${o}`,
                    };
                  })}
                  handleChange={handleChangeMoneda}
                  property={"Moneda"}
                  valueAux={{
                    label: requeriment.moneda
                      ? `${requeriment.moneda}`
                      : "Seleccione...",
                    value: requeriment.moneda || "",
                  }}
                  emptyInputs={[]}
                  styles={{
                    additionalStyleDivSelectList: {
                      alignItems: "left",
                    },
                    fontStyleTitle: {
                      marginTop: "5px",
                      fontWeight: "bold",
                      fontSize: "22px",
                      color: "#7c7b7b",
                      marginLeft: "9px",
                    },
                  }}
                  fontBold={true}
                />
              </div>
              <div className="container-AddReq-item-details">
                <div className="container-r-item-title-details">Cotización</div>
                <div
                  className={`inputGroup ${
                    onFocus == "cotizacion" ? "focused" : ""
                  } ${
                    requeriment.moneda == "PESOS"
                      ? "disabled-input bg-disabled"
                      : "bg-white"
                  }`}
                >
                  <label
                    className={`l ${
                      requeriment.moneda == "PESOS" ? "disabled-input" : ""
                    }`}
                    onClick={() => cotizacionRef.current.focus()}
                  >
                    $
                  </label>
                  <input
                    onFocus={handleFocusCotizacion}
                    onBlur={handleBlurCotizacion}
                    onChange={handleChangeCotizacion}
                    ref={cotizacionRef}
                    type="text"
                    value={formattedCotizacion}
                    className={`label-AddReq-import ${
                      requeriment.moneda == "PESOS" ? "disabled-input" : ""
                    }`}
                    disabled={requeriment.moneda == "PESOS"}
                    name="cotizacion"
                    placeholder="0.00"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="container-AddReq-item-details-text" style={{ marginLeft: "2rem", paddingRight: "2rem" }}>
            <div className="container-r-item-title-details">
              Texto Adicional
            </div>
            <div className="container-input-texto">
              <div className="r-list-item-details-data-v">
                <textarea
                  placeholder="Ingrese texto adicional"
                  className="r-item-text-input"
                  style={{ fontWeight: 600 }}
                  value={requeriment.observ}
                  onChange={(data) => handleChangObservation(data.target.value)}
                ></textarea>
              </div>
            </div>
          </div>

          {globalSettings &&
            globalSettings.requiredSubcuenta == true &&
            globalSettings.codDim !== "" && (
              <div
                style={{ width: "30%", marginLeft: "20px", marginTop: "30px" }}
              >
                <SelectList
                  text={"Subcuenta"}
                  options={subcuentasActivas.map((s) => {
                    return {
                      value: `${s.subCue}`,
                      label: `${s.subCue} - ${s.subCueDescrp}`,
                    };
                  })}
                  handleChange={handleChangeSubcuenta}
                  property={"Subcuenta"}
                  valueAux={{
                    label: subcuentaSelected.subCue
                      ? `${subcuentaSelected.subCue} - ${subcuentaSelected.subCueDescrp}`
                      : "Seleccione...",
                    value: subcuentaSelected.subCue || "",
                  }}
                  emptyInputs={[]}
                  styles={{
                    additionalStyleDivSelectList: {
                      alignItems: "left",
                    },
                    fontStyleTitle: {
                      fontWeight: "bold",
                      fontSize: "22px",
                      color: "#7c7b7b",
                      marginLeft: "9px",
                    },
                  }}
                  fontBold={true}
                />
              </div>
            )}
          {solicitaOrdenCompra && (
          <div className="getOCPDiv">
            <label className="container-r-item-title-details">
              Órdenes de Compra
            </label>
            <div className="inputs-oc-y-checkbox">
              <div className="inputs-codori">
                <DropDownPicker
                  isCreatable
                  numberOnly
                  isDisabled={checkOcApl}
                  placeholder={checkOcApl ? "" : "Escriba un número y presione Enter"}
                  value={requeriment.ocsApl?.nroFor ? requeriment.ocsApl.nroFor : []}
                  onChange={handleChangeOcApl}
                  containerStyle={{ minWidth: "400px", width: "auto" }}
                />
              </div>
              <div className="not-oc-item-inline">
                <input
                  type="checkbox"
                  checked={checkOcApl}
                  onChange={(e) => handlerClickNotOc(e.target.checked)}
                />
                <label className="not-oc-item-label">
                  No tengo Órdenes de Compra
                </label>
              </div>
            </div>
          </div>
          )}

        </div>
        {/*       <div className="container-AddReq-item-details-items">
        <div className="container-r-item-title-details">
          Items: {items.length === 0 ? 0 : items.length - 1}
        </div>
        <div className="container-items-products-rq-gral">
          {items.length > 0 &&
            items.map((c, index) => {
              return (
                <NewProductItm
                  data={c}
                  index={index}
                  key={c.usr_id}
                  productsList={productList}
                  ocpsRecuperadas={[]}
                  agregaItem={(data) => handleagregaItem(data)}
                  modificaItm={(data, indice) => handleChangeItm(data, indice)}
                  borraItem={() => handleDeleteConcept(c, index)}
                />
              );
            })}
        </div>
      </div>
        */}

        {/* Subtabla Conceptos AI */}
        {aiExtractionEnabled && (
          <div className="conceptos-ai-wrapper">
            <div className="conceptos-ai-tabs">
              <button className="conceptos-ai-tab selected">Conceptos</button>
            </div>
            <div className="conceptos-ai-container">
              <div className="conceptos-ai-header">
                <label>Conceptos por Comprobante ({conceptos.length})</label>
              </div>
            <div className="conceptos-ai-items">
              {conceptos.length > 0 && (
                <div className="concepto-item concepto-labels-row">
                  <div className="concepto-row-data">
                    <span className="concepto-num">#</span>
                    <span className="concepto-label concepto-field-desc">Descripción</span>
                    <span className="concepto-label concepto-field-num">Cantidad</span>
                    <span className="concepto-label concepto-field-num">P. Unitario</span>
                    <span className="concepto-label concepto-field-num">Monto</span>
                    {!isUserTypeProv && <span className="concepto-label concepto-erp-inline">Producto ERP</span>}
                    <span className="concepto-label concepto-delete-col"></span>
                  </div>
                </div>
              )}
              {conceptos.map((concepto, idx) => (
                <div className="concepto-item" key={idx}>
                  <div className="concepto-row-data">
                    <span className="concepto-num">{idx + 1}</span>
                    <input
                      className="concepto-field concepto-field-desc"
                      value={concepto.description}
                      disabled
                      title={concepto.description}
                    />
                    <input
                      className="concepto-field concepto-field-num"
                      type="number"
                      value={concepto.quantity}
                      title="Cantidad"
                      onChange={(e) => {
                        const newConceptos = [...conceptos];
                        const val = e.target.value === "" ? "" : Number(e.target.value);
                        newConceptos[idx] = { ...newConceptos[idx], quantity: val };
                        setConceptos(newConceptos);
                      }}
                    />
                    <input
                      className="concepto-field concepto-field-num"
                      type="number"
                      value={concepto.unitPrice}
                      title="P. Unitario"
                      onChange={(e) => {
                        const newConceptos = [...conceptos];
                        const val = e.target.value === "" ? "" : Number(e.target.value);
                        newConceptos[idx] = { ...newConceptos[idx], unitPrice: val };
                        setConceptos(newConceptos);
                      }}
                    />
                    <input
                      className="concepto-field concepto-field-num concepto-field-total"
                      type="number"
                      value={concepto.amount}
                      title="Monto"
                      onChange={(e) => {
                        const newConceptos = [...conceptos];
                        const val = e.target.value === "" ? "" : Number(e.target.value);
                        newConceptos[idx] = { ...newConceptos[idx], amount: val };
                        setConceptos(newConceptos);
                      }}
                    />
                    {!isUserTypeProv && <div className="concepto-erp-inline">
                      <AutocompleteV2
                        placeholder="Producto ERP"
                        value={
                          concepto.codigoERP
                            ? `${concepto.codigoERP.tipPro}${concepto.codigoERP.artCod} - ${concepto.codigoERP.descrp} (${concepto.codigoERP.codRed})`
                            : ""
                        }
                        setValue={(val) => {
                          const newConceptos = [...conceptos];
                          if (val && val.includes(" - ")) {
                            const codeStr = val.split(" - ")[0].trim();
                            const prod = productListActivos.find(
                              (p) => `${p.tipPro}${p.artCod}`.replace(/\s+/g, '') === codeStr.replace(/\s+/g, '')
                            );
                            if (prod) {
                              newConceptos[idx] = {
                                ...newConceptos[idx],
                                codigoERP: {
                                  tipPro: prod.tipPro || "",
                                  artCod: prod.artCod || "",
                                  codRed: prod.codRed || "",
                                  descrp: prod.descrp || "",
                                },
                              };
                            }
                          } else {
                            newConceptos[idx] = {
                              ...newConceptos[idx],
                              codigoERP: null,
                            };
                          }
                          setConceptos(newConceptos);
                        }}
                        dataSuggestions={productListActivos.map((p) => ({
                          code: `${p.tipPro}${p.artCod}`,
                          descrp: `${p.descrp} (${p.codRed})`,
                        }))}
                        ocpsRecuperadas={true}
                        width="100%"
                        height="34px"
                      />
                    </div>}
                    <button
                      className="concepto-delete-btn"
                      title="Eliminar concepto"
                      onClick={() => {
                        setConceptos(conceptos.filter((_, i) => i !== idx));
                      }}
                    >
                      ✕
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        )}
      </>
      }

        <div className="footer-botones-form">
          {isAdminOrControl && (
            <div className="skip-validation">
              <input
                type="checkbox"
                checked={skipValidation}
                onChange={(e) => setSkipValidation(e.target.checked)}
              />
              <label className="label-skip-validation">
                Guardar sin validar adjunto
              </label>
            </div>
          )}

          {/* <div className='container-button-rq-save-new2'><button className='button-rq-save-new2' onClick={}>Agregar Archivo  </button></div> */}
          <div className="container-button-rq-save-new2">
            <div
              className={`${
                selectionColor
                  ? "button-rq-save-new2-selected"
                  : selectedFiles.length >= 1
                    ? "disabled-file"
                    : "button-rq-save-new2"
              }`}
            >
              <div
                className={`file-select ${
                  selectedFiles.length >= 1 ? "disabled-cursor" : ""
                }`}
                id="src-file1"
              >
                <input
                  onFocus={cambioColorSeleccion}
                  type="file"
                  name="src-file1"
                  aria-label="Agregar Archivo .pdf .jpg .jpeg"
                  onChange={handleFileInputChange}
                  disabled={selectedFiles.length >= 1}
                  accept=".pdf, .jpg, .jpeg"
                />
              </div>
            </div>
          </div>

          <div className="container-new-rq-files">
            <ul className="container-new-rq-files-details">
              {selectedFiles.map((file) => (
                <li key={file.name}>
                  {file.name}
                  <FontAwesomeIcon
                    onClick={() => eliminaFile(file)}
                    style={{
                      cursor: "pointer",
                      color: "red",
                      marginLeft: "20px",
                    }}
                    icon={faXmark}
                  />
                </li>
              ))}
            </ul>
          </div>

          {selectedFiles.length > 0 && !edicion && aiExtractionEnabled && (
            <div style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
              <button
                onClick={() => handleAutoFillFromDocument()}
                disabled={processingDocumentAI}
                style={{
                  backgroundColor: "#4a90d9",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  padding: "8px 16px",
                  cursor: processingDocumentAI ? "not-allowed" : "pointer",
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  opacity: processingDocumentAI ? 0.7 : 1,
                }}
              >
                {processingDocumentAI ? (
                  <>
                    <FontAwesomeIcon icon={faSpinner} spin />
                    Escaneando...
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                    Escanear y completar campos
                  </>
                )}
              </button>
            </div>
          )}
        </div>

        {globalSettings?.permiteAdjuntarDocsAdicionales && (
        <div className="aditionalDocumentationContainer">
          <h5>Adjuntar documentación adicional</h5>
          <div
            className="aditionalDocsInputContainer"
            onClick={() => inputRef.current.click()}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDropAditionalDocs}
          >
            <input
              type="file"
              style={{ display: "none" }}
              ref={inputRef}
              onChange={handleChangeAditionalDocs}
            />

            <h5>Suelte sus archivos aqui o presione para buscar en sus documentos</h5>
          </div>

          {aditionalDocs?.some((a) => a.action !== "DELETE") && (
            <div
              className="docsContainer"
              style={{ marginTop: 8, display: "flex", flexDirection: "column", gap: 4 }}
            >
              {aditionalDocs.map((a, i) =>
                a.action === "DELETE" ? null : (
                  <div key={i} style={{ display: "flex", gap: 8, alignItems: "center" }}>
                    <span>{a.name}</span>
                    <button
                      style={{
                        backgroundColor: "red",
                        borderRadius: 5,
                        color: "white",
                        fontWeight: "bold",
                        border: 0,
                      }}
                      onClick={() => deleteAditionalDoc(i)}
                    >
                      X
                    </button>
                  </div>
                )
              )}
            </div>
          )}
        </div>
        )}

        <div className="container-button-rq-save-new">
          <button
            className={`button-rq-save-new ${
              controlBotonEnviar ? "disabled" : ""
            }`}
            disabled={controlBotonEnviar}
            onClick={handleSaveRequirement}
          >
            Finalizar
          </button>
        </div>
        {processingPDF && (
          <div className="modalLoading">
            <div className="modalLoadingContainer">
              <h4>Aguarde mientras se validan los datos</h4>
              <FontAwesomeIcon
                className="loadingIcon"
                icon={faSpinner}
                color="black"
              />
            </div>
          </div>
        )}
        {processingDocumentAI && (
          <div className="modalLoading">
            <div className="modalLoadingContainer">
              <h4>Escaneando documento con IA...</h4>
              <FontAwesomeIcon
                className="loadingIcon"
                icon={faSpinner}
                color="black"
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default FormReq;
